import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { usePostHog } from "@posthog/react";

function PostHogPageView() {
    const location = useLocation();
    const posthog = usePostHog();

    useEffect(() => {
        if (!posthog) {
            return;
        }

        posthog.capture("$pageview", {
            $current_url: window.location.href,
        });
    }, [location.pathname, location.search, location.hash, posthog]);

    return null;
}

export default PostHogPageView;
